<template>
  <div class="banner" :class="{ 'banner--large': isLarge }" v-data-test-id="'banner'">
    <ImageContentful
      :src="desktopSrcInternal"
      :srcMobile="mobileSrcInternal"
      containerSelector=".banner"
      :isBackgroundImage="true"
      :options="{ imageCompression: 71, retinaSupportFactor: 0.5, fit: CONTENTFUL_IMAGE_FIT.fill }"
      class="banner__image"
      :class="{ 'banner__image--faded-out': isFadedOut }"
    />
    <slot></slot>
  </div>
</template>

<script>
import ImageContentful, { CONTENTFUL_IMAGE_FIT } from '@/components/_shared/ImageContentful.vue'

export default {
  name: 'Banner',
  components: {
    ImageContentful,
  },

  props: {
    desktopSrc: {
      type: String,
      required: true,
    },

    mobileSrc: {
      type: String,
    },

    isLarge: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      CONTENTFUL_IMAGE_FIT,
      desktopSrcInternal: '',
      isFadedOut: false,
      mobileSrcInternal: '',
    }
  },

  watch: {
    desktopSrc: 'smoothlyUpdateSrc',
    mobileSrc: 'smoothlyUpdateSrc',
  },

  mounted() {
    this.smoothlyUpdateSrc({ delay: 10 })
  },

  methods: {
    /**
     * Smooth image update: Fades out image, replaces image src and fades in image again.
     */
    smoothlyUpdateSrc({ delay = 500 }) {
      if (this.isFadedOut) return
      this.isFadedOut = true
      setTimeout(() => {
        this.desktopSrcInternal = this.desktopSrc
        this.mobileSrcInternal = this.mobileSrc
        this.isFadedOut = false
      }, delay)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Banner.scss';
</style>
